/** AreaLight3D parser and formatter registration. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseAreaLight3D } from './parser';
import { formatAreaLight3DProperties } from './propertyFormatter';
const areaLight3DRegistration = {
    typeName: 'AreaLight3D',
    parser: parseAreaLight3D,
    propertyFormatter: formatAreaLight3DProperties,
};
nodeRegistry.register(areaLight3DRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map